// Lib Imports
import PropTypes from "prop-types";
const propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired
};
export default propTypes;